<template>
  <div class="fulldashboard">
    <div v-if="!isHidden" class="backgroundOpacity">
      <button class="xmarkButton" v-on:click="component=null, isHidden=true" >X</button>
    </div>
    <div class="dashboard-margin">
      
    <div class="containerFormular feedbackcontainer">
      <component v-bind:is="component" :brand="form.brand" :designation="form.designation" :description="form.description" :image="imageUpload.imageUrl"></component>
    </div>
    <div class="containerFormular">
      <form
        action="#"
        @submit.prevent="submit"
      >
        <input
          type="hidden"
          name="MAX_FILE_SIZE"
          value="1000000"
        >
        <div class="spalte">
          <div class="inputSection">
            <div class="inputSectionPreText">
              EAN<p class="textColorOrange">
                *
              </p>
            </div>
            <input
              id="ean"
              v-model="form.ean"
              type="text"
              name="EAN"
              class="inputSectionInputField"
              placeholder="8-/13-stellige EAN Nummer eintragen"
              value
              required
            >
          </div>
          <div class="inputSection">
            <div class="inputSectionPreText">
              Marke<p class="textColorOrange">
                *
              </p>
            </div>
            <input
              v-model="form.brand"
              type="text"
              name="Marke"
              class="inputSectionInputField"
              placeholder="Markenname eintragen"
              required
            >
          </div>
          <div class="inputSection">
            <div class="inputSectionPreText">
              Bezeichnung<p class="textColorOrange">
                *
              </p>
            </div>
            <input
              v-model="form.designation"
              type="text"
              name="Bezeichnung"
              class="inputSectionInputField"
              placeholder="Produktbezeichnung eintragen"
              required
            >
          </div>
          <div class="inputSection category">
            Zu welcher Kategorie gehört der Artikel?<p class="textColorOrange">
              *
            </p>
          </div>
          <div class="inputSection">
            <div class="inputSectionPreText category1">
              Hauptkategorie<p class="textColorOrange">
                *
              </p>
            </div>
            <div class="dropdown dropdownStyle">
              <b-form-select
                v-model="formSelected"
                class="dropdownFont"
                :options="productCategories"
                
                @change="onChangeMainCategory"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    {{ getTranslation(selectorData.maincategory) || selectorData.maincategory}}
                  </b-form-select-option>
                </template>
              </b-form-select>
            </div>
          </div>
          <div class="inputSection">
            <div class="inputSectionPreText category1">
              Unterkategorie<p class="textColorOrange">
                *
              </p>
            </div>
            <div class="dropdown dropdownStyle">
              <b-form-select

                v-model="subformSelected"
                class="dropdownFont"
                :options="productSubCategories"
                
                @change="onChangeSubCategory"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    {{ getTranslation(selectorData.subcategory) || selectorData.subcategory }}
                  </b-form-select-option>
                </template>
              </b-form-select>
            </div>
          </div>
          <div class="inputSection">
            <div class="inputSectionPreText">
              Beschreibung<p class="textColorOrange">
                *
              </p>
            </div>
            <textarea
              v-model="form.description"
              class="inputSectionInputField"
              placeholder="Produktbeschreibung eintragen"
              name="Beschreibung"
              rows="8"
              cols="80"
              required
            />
          </div>
        </div>
        <div class="spalte">
          <div class="inputSection">
            <div class="inputSectionPreText">
              Produktgröße
            </div>
            <input
              v-model="form.productSize"
              type="text"
              name="Produktgröße"
              class="inputSectionInputField"
              placeholder="Produktgröße eintragen(z.B. 200ml, 30g, etc.)"
            >
          </div>
          <div class="inputSection">
            <div class="inputSectionPreText">
              Nährwerte
            </div>
            <textarea
              v-model="form.nutrition"
              class="inputSectionInputField"
              placeholder="Nährwerte eintragen"
              name="Nährwerte"
              rows="4"
              cols="80"
            />
          </div>
          <div class="inputSection">
            <div class="inputSectionPreText">
              Zutaten und Allergene
            </div>
            <textarea
              v-model="form.ingredients"
              class="inputSectionInputField"
              placeholder="Zutaten und Allergene eintragen"
              name="Zutaten"
              rows="4"
              cols="80"
            />
          </div>
          <div class="inputSection">
            <div class="inputSectionPreText">
              Keywords<p class="textColorOrange">
                *
              </p>
            </div>
            <textarea
              v-model="form.keywords"
              class="inputSectionInputField"
              placeholder="passende Keywords zum Produkt eintragen"
              name="Keywords"
              rows="4"
              cols="80"
              required
            />
          </div>
          <div class="inputSection">
            <div class="inputSectionPreText">
              Produktbild<p class="textColorOrange">
                *
              </p>
            </div>
            <input
              type="file"
              name="ImageURL"
              class="inputSectionInputField"
              accept="image/*"
              
              @change="onFilePicked"
            >
          </div>
          <div class="inputSection">
            <div class="dateiUploadInfo">
              Bitte randlos freigestelltes Produktbild als JPEG oder PNG auswählen. Maximale Dateigröße 1MB (1000KB).
            </div>
          </div>
          <div class="dateiUploadInfo pflichtfeld">
          * = Pflichtfeld
           </div>
          
          <div class="submit">
            <input
              type="submit"
              name="abgesendet"
              class="submitbutton"
              value="Artikel hinzufügen"
              >
          </div>
          
        </div>
        
      </form>
      <div class="preview">
            <button class="showPreviewButton" v-on:click="component='productFeedback', isHidden=false" >Vorschau zeigen</button>
      </div>
      
    </div>

    <notifications
        class="dashboardAlert"
        group="upload-notifications"
        position="center bottom"
      />
  </div>
  </div>
</template>
<script>
    import { mapGetters } from "vuex";
    import firebase from "firebase";
    import { BFormSelect } from 'bootstrap-vue'
    import translationMap from '../../res/translationMap'
    import ArticleStyleProductViewVue from './ArticleStyleProductView.vue';

    //constants
    const baseCategoryPath = "categories/food/";

    export default {
        components: {
            'b-form-select': BFormSelect,
            'productFeedback': ArticleStyleProductViewVue,
        },
        props:[
            'ean',
            'brand',
            'description',
            'designation',
            'productSize',
            'nutrition',
            'ingredients',
            'keywords',
            'image',
            'maincategory',
            'subcategory',
            'isEdit',
          ],
        data() {
            return {
                form: { 
                    ean: this['ean'],
                    brand: this['brand'],
                    designation: this['designation'],
                    description: this['description'],
                    productSize: this['productSize'],
                    nutrition: this['nutrition'],
                    ingredients: this['ingredients'],
                    keywords: this['keywords'],
                    imageUrl: this['image'],
                },
                imageUpload: {
                    imageName: "",
                    imageUrl: this['image'],
                    imageFile: ""
                },
                formSelected: null,
                subformSelected: null,
                productCategories: [],
                productSubCategories: [],
                selectorData: {
                    maincategory: this['maincategory'],
                    subcategory: this['subcategory']
                },
                showDismissibleAlert: false,
                error: null,
                component: null,
                isHidden: true,
                isEdit2: this['isEdit'],
            };
        },
        computed: {
            // map `this.user` to `this.$store.getters.user`
            ...mapGetters({
                user: "user"
            })
        },
        created () {
            // fetch the data
            if (this.isEdit2 === false){
                this.form.ean = ""
            } else {
                this.form.ean = '',
                this.form.brand = '',
                this.form.designation = '',
                this.form.description = '',
                this.form.productSize = '',
                this.form.nutrition = '',
                this.form.ingredients = '',
                this.form.keywords = '',
                this.form.imageUrl = '',
                this.selectorData.maincategory = 'Oberkategorie wählen',
                this.selectorData.subcategory = 'Unterkategorie wählen'
            }
            this.fetchData(baseCategoryPath);
        },
        methods: {
            onChangeMainCategory(option){
               
                    this.selectorData.maincategory = option;
                    // reset sub category that we dont have the wrong identifier in here
                    this.selectorData.subcategory = "";
                    this.fetchSubcategoryData(option);
                    this.productSubCategories = [];
                
                
            },
            onChangeSubCategory(option){
                this.selectorData.subcategory = option;
            },
            getTranslation(origin){
                if(!origin || origin === "") return undefined
                return translationMap.get(origin)
            },
            fetchData(path) {
                const vm = this;
                try {
                    const productCategoriesFBRef = firebase.database().ref(path);
                    productCategoriesFBRef.once('value', function(snapshot) {
                        snapshot.forEach(function(childSnapshot) {
                            const childKey = childSnapshot.key;
                            const translatedKey = vm.getTranslation(childKey.toString());
                            vm.productCategories.push({
                                value: `${childKey.toString()}`, text: translatedKey || childKey.toString(),
                            })
                        });
                    });
                } catch (e) {
                    this.$notify({
                        group: 'list-notifications',
                        title: 'Fehler!',
                        text: `Es gab einen Fehler beim Abrufen der Produktkategorien: ${e.message}`,
                        type: 'error',
                        duration: 5000,
                    });
                }
            },
            fetchSubcategoryData(maincategory) {
                const vm = this;
                try {
                    const productCategoriesFBRef = firebase.database().ref(baseCategoryPath + maincategory);
                    productCategoriesFBRef.once('value', function(snapshot) {
                        snapshot.forEach(function(childSnapshot) {
                            const childKey = childSnapshot.key;
                            const translatedKey = vm.getTranslation(childKey.toString());
                            vm.productSubCategories.push({
                                value: `${childKey.toString()}`, text: translatedKey || childKey.toString(),
                            })
                        });
                    });
                } catch (e) {
                    this.$notify({
                        group: 'list-notifications',
                        title: 'Fehler!',
                        text: `Es gab einen Fehler beim Abrufen der Produktkategorien: ${e.message}`,
                        type: 'error',
                        duration: 5000,
                    });
                }
            },
            clearImageUploadData() {
                this.imageUpload.imageName = "";
                this.imageUpload.imageFile = null;
                this.imageUpload.imageUrl = "";
            },
            clearFormular(){
                    this.form.ean = '',
                    this.form.brand = '',
                    this.form.designation = '',
                    this.form.description = '',
                    this.form.productSize = '',
                    this.form.nutrition = '',
                    this.form.ingredients = '',
                    this.form.keywords = '', 
                    this.form.imageUrl = '',
                    this.selectorData.maincategory = '',
                    this.selectorData.subcategory = ''
            },
            onFilePicked(e) {

                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.imageUpload.imageName = files[0].name;
                    if (this.imageUpload.imageName.lastIndexOf(".") <= 0) {
                        return;
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener("load", () => {
                        this.imageUpload.imageUrl = fr.result;
                        this.imageUpload.imageFile = files[0]; // this is an image file that can be sent to server
                        const imageFileSize = this.imageUpload.imageFile.size; // in kb
                        if(imageFileSize > 1000000) {
                            this.$notify({
                                group: 'upload-notifications',
                                title: 'Fehler!',
                                text: `Bildgröße zu groß! Maximal 1mb (1000kb) erlaubt.`,
                                type: 'error',
                                duration: 5000,
                            });
                            this.clearImageUploadData();
                        }
                    });
                } else {
                    this.$notify({
                        group: 'upload-notifications',
                        title: 'Fehler!',
                        text: `Es gab einen Fehler beim Dateiupload - bitte erneut versuchen.`,
                        type: 'error',
                        duration: 5000,
                    });
                    this.clearImageUploadData();
                }
            },
            async uploadImage({ userId }) {
                // get storage ref
                const storageRef = firebase.storage().ref();
                // get node for the image
                const userStorageRef = storageRef.child(`/manufacturer/${userId}/${this.form.ean}`);
                // upload the image
                const uploadResult = await userStorageRef.put(this.imageUpload.imageFile);
                // get download url and save it to the form
                const downloadURL = await uploadResult.ref.getDownloadURL();
                 this.form.imageUrl = await downloadURL;
            },
            async submit() {
                // sanitize input
               const userId = firebase.auth().currentUser.uid;
                if (this.isEdit2 === true){
                     
                    if (this.selectorData.maincategory === "" || this.selectorData.subcategory === ""){
                    this.$notify({
                        group: 'upload-notifications',
                        title: 'Fehler!',
                        text: `Bitte wählen Sie eine Ober- und Unterkategorie für Ihr Produkt.`,
                        type: 'error',
                        duration: 5000,
                    });
                    return
                   }
                   if (this.imageUpload.imageName){
                      try {
                       
                          await this.uploadImage({ userId });
                       } catch (e){
                          this.error = "File upload could not be completed: " + e.message;

                          return;
                      } 
                   }
              
              
                if(!(this.form.ean.length === 8 || this.form.ean.length === 13)){
                    this.$notify({
                        group: 'upload-notifications',
                        title: 'Fehler!',
                        text: `EAN muss 8 oder 13 Zeichen haben!`,
                        type: 'error',
                        duration: 5000,
                    });
                    return;
                }
                const uploadData = {
                    ...this.form,
                    ...this.selectorData,
                    creationDate: new Date().toISOString(),
                    manufactureID: userId
                };

                
                await firebase.database().ref('/manufacture/' + userId + "/products/" + this.form.ean).set(true);
                await firebase.database().ref('/products/' + this.form.ean).set(uploadData);

                this.$notify({
                    group: 'upload-notifications',
                    title: 'Erfolg:',
                    text: `Änderung wurde gespeichert`,
                    type: 'success',
                    duration: 5000,
                });
                // proper reload of the document
                 
                } else {
                    if (this.selectorData.maincategory === "" || this.selectorData.subcategory === ""){
                    this.$notify({
                        group: 'upload-notifications',
                        title: 'Fehler!',
                        text: `Bitte wählen Sie eine Ober- und Unterkategorie für Ihr Produkt.`,
                        type: 'error',
                        duration: 5000,
                    });
                }
                
                try {
                          await this.uploadImage({ userId });
                       } catch (e){
                          this.error = "File upload could not be completed: " + e.message;
                          return;
                      } 

                const userId = firebase.auth().currentUser.uid;

                if(!(this.form.ean.length === 8 || this.form.ean.length === 13)){
                    this.$notify({
                        group: 'upload-notifications',
                        title: 'Fehler!',
                        text: `EAN muss 8 oder 13 Zeichen haben!`,
                        type: 'error',
                        duration: 5000,
                    });
                    return;
                }
                const uploadData = {
                    ...this.form,
                    ...this.selectorData,
                    creationDate: new Date().toISOString(),
                    manufactureID: userId
                };
                await firebase.database().ref('/manufacture/' + userId + "/products/" + this.form.ean).set(true);
                await firebase.database().ref('/products/' + this.form.ean).set(uploadData);
                
                this.clearFormular();

                this.$notify({
                    group: 'upload-notifications',
                    title: 'Erfolg:',
                    text: `Der Upload hat funktioniert!`,
                    type: 'success',
                    duration: 5000,
                });
                // proper reload of the document
                this.$forceUpdate();    
                }

                
            },
            

        }
    };
</script>

<style>
.backgroundOpacity{
      position: fixed;
      background: #2B2C2B;
      opacity: 0.8;
      border-radius: 10px;
      width: 100%;
      height: 100%;
      margin-top: -50px;
    }

.dashboard-margin {
  margin-top: 50px;
}
.containerFormular
{
    display: table;
    margin: 0 auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-radius:10px;
    background-color: #f7f7f7;
}
.feedbackContainer {
  position: fixed;
  margin-left: -150px;
}
.xmarkButton{
  display: table;
  margin: 0 auto;
  margin-top: 10px;
  height: 40px;
  width: 40px;
  border: 0px solid;
  background-color: #f88623;
  border-radius: 20px;
  color: white;
}
.spalte 
{
    width: 420px;
    border-width: 2px;
    border-color: #F88623;
    float: left;
    padding-left: 10px;
    padding-right: 30px;
    padding-top: 30px;
    padding-bottom: 0;
}
.inputSection
{
    overflow: hidden;
    margin-top: 15px;
    margin-bottom: 15px;
}
.inputSectionPreText
{
    margin: auto;
    text-align: right;
    float: left;
    width: 30%;
}
.inputSectionInputField
{
    float: right;
    margin: auto;
    padding : 5px;
    width: 65%;
    border: solid 1px;
    font-family: 'Exo', sans-serif;
    border-radius: 10px;
    border-color: #ebebeb;
    background-color: white;
}
    textarea {
        resize: none;
        font-family: 'Exo', sans-serif;
    }
    .category
    {
        text-align: right;
    }
    .category1
    {
        font-size: 12px;
    }
    .dropdownStyle
    {
        width: 65%;
        padding: 5px;
        font-family: 'Exo', sans-serif;
        float: right;
    }
    .pflichtfeld
    {
        text-align: right;
        padding-left: 0;
        padding-bottom: 10px;
        color: #f88623;
    }
    .textColorOrange
    {
        color: #f88623;
        display: inline;
    }
    .dropdownFont
    {
        font-size: 10px;
    }
    .dateiUploadInfo
{
    font-size: 12px;
    text-align: right;
    color: #353736;
    padding-right: 10px;
}
.submit
{
    margin-top: -20px;
    padding-right: 85px;
    margin-bottom: 50px;
}
.submitbutton
{
    background-image:linear-gradient(270deg, #ff7600, #fa9842);
    font-family: 'Exo', sans-serif;
    border-radius:20px;
    border-width: 0px;
    height: 40px;
    color: white;
    font-weight: bold;
    font-size: 15px;
    padding : 10px;
    float: right;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.preview{
    padding-right: 135px;
}
.showPreviewButton{
  background-image:linear-gradient(270deg, #ff7600, #fa9842);
  font-family: 'Exo', sans-serif;
  height: 20px;
  float: right;
  border: 0px;
  border-radius: 10px;
  width: 100px;
  color: white;
  margin: 10px;
  
}
.dashboardAlert{
  margin-left: 150px;
}

@media screen and (max-width:1313px)
{
    .spalte
    {
        padding-bottom: 0px;
    }
    .containerFormular
    {
        width: 460px;
    }
    .feedbackContainer
    {
        margin-left: 75px;
    }
    .preview{
      padding-right: 175px;
    }
}

</style>